import { Exclude, Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsIconography extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public icon: string;

  @Expose()
  public name: string;

  @Expose()
  public organization: string;

  @Expose()
  public uploader: string;

  @Expose({ name: 'updatedTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public updatedAt: Date;

  @Expose({ name: 'createdTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public createdAt: Date;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
